import { NextSeo } from 'next-seo';
import React from 'react';
import CollectionGrid from '../components/CollectionGrid';
import { getCollection } from './api/_utils/collection';
import PageHeader from '../components/PageHeader';
import config from '../config';
import Container from '../components/Container';

export async function getServerSideProps(context) {
  const assets = await getCollection(process.env.NEXT_PUBLIC_V1_WALLET);

  return {
    props: { assets },
  };
}

function Collection({ assets }) {
  return (
    <>
      <NextSeo title={`V1 Collection - ${config.siteName}`} />

      <PageHeader
        heading={'AlgoDaruma - V1'}
        description='What do you get when you combine the love Algorand technology and the love of Japanese culture? You get ALGODARUMA!'
      />

      <Container>
        <CollectionGrid assets={assets} />
      </Container>
    </>
  );
}

export default Collection;
